// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"5":"1e825283","91":"d66e6c92","220":"31259fa4","314":"6fc74e74","337":"ff875eca","413":"f94352ee","554":"a6a785ad","746":"06251c43"}[chunkId] + ".js";
};